import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"

import darkFork from "../../../images/svg/top/dark/fork-dark.svg"
import lightFork from "../../../images/svg/top/light/fork-light.svg"
import YuklemeTuruInput from "../sections/yuk/inputs/YuklemeTuruInput"
import YukunTuruInput from "../sections/yuk/inputs/YukunTuruInput"
import PaketlemeTypesSection from "../sections/paketleme/PaketlemeTypesSection"
import YukAdrCheckbox from "../sections/yuk/inputs/YukAdrCheckbox"
import AgirlikBirimiInput from "../sections/yuk/inputs/AgirlikBirimiInput"
import ToplamAgirlikInput from "../sections/yuk/inputs/ToplamAgirlikInput"
import ToplamHacimInput from "../sections/yuk/inputs/ToplamHacimInput"
import YukAciklamaTextarea from "../sections/yuk/inputs/YukAciklamaTextarea"
import YukunSigortaDegeri from "../sections/yuk/inputs/YukunSigortaDegeri"
import YukSigortaTeklifBtn from "../sections/yuk/others/YukSigortaTeklifBtn"
import BtnOutline from "../../shared/button/BtnOutline"
import {MdKeyboardArrowRight, MdKeyboardArrowLeft} from "react-icons/md"
import { scrollToTop } from "../../../helper/scrollToTop"
import YukAdrDescriptionInput from "../sections/yuk/inputs/YukAdrDescriptionInput"
import YukunUzerineBaskaYukCheckBox from "../sections/paketleme/inputs/YukunUzerineBaskaYukCheckBox"
import InputText from "../../shared/input/new/InputText"
import InputDate from "../../shared/input/new/InputDate"
import { updateYukData } from "../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    width: auto;

    .section-item{
        display: flex;
        flex-direction: column;


        .top-wrapper{
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 20px;

            img{
                width: 25px;
                height: 25px;
            }

            .title{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-xl);
                color: ${({theme}) => theme.mainTextColor};
            }
        }

        .input-list{
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-left: 40px;


            .margin-left{
                margin-left: 20px;
            }


            .input-grp{
                display: flex;
                align-items: center;
                gap: 10px;

            }

            .free-zone-field {
                width: 500px;
                display: flex;
                align-items: center;
                gap: 10px;
                color: ${({theme}) => theme.mainTextColor};
                font-size: var(--font-size-sm);
                cursor: pointer;
            }
        }
    }

    .bottom-btn-container{
        width: 100%;
        padding: 50px;
        display: flex;
        justify-content: space-between;

        .icon{
            fill: var(--color-main);
            font-size: 1.6rem;
        }

        span{
            color: ${({theme}) => theme.mainTextColor};
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
        }

    }
`  

const LoadSection = ({setPhase}) => {
    const dispatch = useDispatch()
    const {yukData} = useSelector(state => state.updateLoad)
    const {theme } = useSelector(state => state.layout)
  return (
    <Container>
        <div className="section-item">
            <div className="top-wrapper">
                {theme === "light" ? <img src={theme === "light" ? darkFork: lightFork} alt="" /> : ""}
                <h3 className="title">Yük</h3>
            </div>

            <div className="input-list">
                <YuklemeTuruInput data={yukData} isRequired={true} name={"yuklemeTuru"}/>
                <YukunTuruInput data={yukData} isRequired={false} name={"yukunTuru"}/>
                <div className="margin-left">
                    <YukAdrCheckbox data={yukData} isRequired={false} name={"yukAdr"}/>
                </div>
                {
                    yukData.yukADR && 
                    <YukAdrDescriptionInput data={yukData} isRequired={false} name={"yukAdrDescription"}/>
                }
                <div className="margin-left">
                    <YukunUzerineBaskaYukCheckBox data={yukData}/>
                </div>
                <div className="input-grp">
                    <AgirlikBirimiInput data={yukData} name={"agirlikBirimi"} isRequired={false}/>
                    {
                        (yukData.agirlikBirim.value && yukData.agirlikBirim.value !== 3) &&
                        <ToplamAgirlikInput data={yukData} name={"toplamAgirlik"} isRequired={true}/>
                    }
                </div>
                <div className="input-grp">
                    <ToplamHacimInput data={yukData} name={"toplamHacim"} isRequired={false}/>
                </div>
                <YukAciklamaTextarea data={yukData} name={"yukAciklama"} isRequired={false}/>

                <InputText data={yukData.companyLoadNumber} setData={(e) => dispatch(updateYukData({companyLoadNumber: e.target.value}))} labelText="Booking No / Firma Yük No" inputWidth="500px" name="companyLoadNumber" />
                <InputText data={yukData.customsPlace} setData={(e) => dispatch(updateYukData({customsPlace: e.target.value}))} labelText="Gümrük Yeri" inputWidth="500px" name="customsPlace" />
                <InputDate data={yukData.vesselDate} setData={(e) => dispatch(updateYukData({vesselDate: e.target.value}))} labelText="Gemi Tarihi" inputWidth="500px" name="vesselDate" />
                <label className="free-zone-field">
                    <input type="checkbox" checked={Boolean(yukData.isFreeZone)} onChange={(e) => dispatch(updateYukData({isFreeZone: e.target.checked}))} />
                    Serbest Bölge
                </label>

                <div className="input-grp">
                    <YukunSigortaDegeri data={yukData} name={"yukSigortaDeger"} isRequired={false}/>
                    {/* <YukSigortaTeklifBtn/> */}
                </div>
                <div className="paketleme-section-container">
                    {/* <PaketlemeSummary/> */}
                    <PaketlemeTypesSection />
                </div>
            </div>
        </div>
        <div className="bottom-btn-container">
            <BtnOutline height={"40px"} width={"120px"} radius={"10px"}  handleClick={() => {setPhase({id: 3, name:"Rota Planlama"});scrollToTop()}}>
                <MdKeyboardArrowLeft className="icon"/>
                <span>Rota Planlama</span>
            </BtnOutline>
            <BtnOutline height={"40px"} width={"120px"} radius={"10px"}  handleClick={() => {setPhase({id: 5, name:"Araç"});scrollToTop()}}>
                <span>Araç</span>
                <MdKeyboardArrowRight className="icon"/>
            </BtnOutline>
        </div>
    </Container>
  )
}

export default LoadSection
